export default "__VITE_ASSET__C8UcFjB0__"